/**
 * Tracking Events
 */

export interface AnalyticsContext {
  [key: string]: unknown;
}

let globalContext: AnalyticsContext = {};

export const Analytics = {
  setGlobalContext: (context: AnalyticsContext) => {
    globalContext = { ...globalContext, ...context };
  },

  getGlobalContext: (): AnalyticsContext => ({ ...globalContext }),

  trackEvent: (eventName: string, params?: Record<string, unknown>) => {
    const enrichedParams = {
      ...globalContext,
      ...params,
    };
    
    window?.analytics?.track(eventName, enrichedParams);
  },

  pageViewed: (pageName?: string) => {
    const pageParams = {
      ...globalContext,
      device: navigator?.userAgent,
      title: window?.document?.title,
      url: window?.location?.href,
      path: window?.location?.pathname,
      search: window?.location?.search,
      referrer: window?.document?.referrer,
      env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    };
    
    window?.analytics?.page(pageName ?? undefined, pageParams);
  },

  identify: (userId: number | string, traits?: Record<string, unknown>) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error

    window?.analytics?.identify(userId, traits);
  },
};
